import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { StudentStudyDay } from "@lingoshade/domain";

export default function StudentDaySummary({
  day,
  canTeach,
}: {
  day?: StudentStudyDay | null;
  canTeach: boolean;
}): React.ReactElement {
  const { t, i18n } = useTranslation("texts");
  const parts: string[] = [];
  if (day?.practiceSeconds) {
    const seconds = day.practiceSeconds;
    const duration = new Intl.NumberFormat(i18n.language, {
      style: "unit",
      unit: seconds < 60 ? "second" : "minute",
      unitDisplay: "short",
      maximumFractionDigits: 0,
    }).format(seconds < 60 ? seconds : seconds / 60);
    parts.push(t("students.lastDay.textTime", { duration }));
  }
  if (day?.completedDictations)
    parts.push(
      day.lastDictationAccuracy === null
        ? t("students.lastDay.dictations", { count: day.completedDictations })
        : t("students.lastDay.dictationsResult", {
            count: day.completedDictations,
            accuracy: new Intl.NumberFormat(i18n.language, {
              maximumFractionDigits: 1,
            }).format(day.lastDictationAccuracy),
          }),
    );
  if (day?.wordsAdded)
    parts.push(t("students.lastDay.wordsAdded", { count: day.wordsAdded }));
  if (day?.wordsReviewed)
    parts.push(
      t("students.lastDay.wordsReviewed", { count: day.wordsReviewed }),
    );
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ overflowWrap: "anywhere", lineHeight: 1.5 }}
    >
      {!canTeach
        ? t("students.lastDay.proRequired")
        : parts.length
          ? parts.join(" · ")
          : t("students.lastDay.empty")}
    </Typography>
  );
}
